import Navigation from "../landingPage/NavigationHeader";
import Footer from "../landingPage/Footer";
import ExistingGroupsSection from "./ExistingGroupsSection";
import ContinueGroupSection from "./ContinueGroupSection";
import BenefitsSection from "./BenefitsSection";
import MigrationFaqs from "./MigrationFaqs";
import HeroSection from "./HeroSection";
import CTASection from "./CTASection";

export default function UplusMigrationPage() {
  return (
    <div className="bg-white dark:bg-defaultBlack overflow-x-hidden flex flex-col">
      <Navigation />
      <HeroSection />
      <MainSection>
        <BenefitsSection />
        <ExistingGroupsSection />
        <ContinueGroupSection />
        <MigrationFaqs />
        <CTASection />
      </MainSection>
      <Footer />
    </div>
  );
}

const MainSection = ({ children }) => {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
  );
};
